// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2-8ee","checkboxCol":"Table_checkboxCol__1R1XT","emailCol":"Table_emailCol__2tfI4","actionCol":"Table_actionCol__2rkGY"};